import { render } from "./ConfigMealSharing.vue?vue&type=template&id=2321be67&scoped=true"
import script from "./ConfigMealSharing.vue?vue&type=script&lang=js"
export * from "./ConfigMealSharing.vue?vue&type=script&lang=js"

import "./ConfigMealSharing.vue?vue&type=style&index=0&id=2321be67&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2321be67"]])

export default __exports__